import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { RoleUserSelect as LocalRoleUserSelect } from '../../components/RoleUserSelect'

export const RoleUserSelect = connect(
  LocalRoleUserSelect,
  mapReadPretty(LocalRoleUserSelect, {
    disabled: true
  })
)
